module.exports = __webpack_public_path__ + "static/media/travel-travel@2x.115c7b28.png";